/**
 * Manages practiceContext in sessionStorage — tracks how many accuracy/fluency
 * practice rounds the student has done today.
 */
export const updatePracticeContext = (pageType: 'accuracy' | 'fluency') => {
  const today = new Date().toLocaleDateString(); // User's timezone
  const stored = sessionStorage.getItem('practiceContext');

  let contextData = {
    date: today,
    accuracyCount: 0,
    fluencyCount: 0,
    current: ''
  };

  if (stored) {
    try {
      const parsed = JSON.parse(stored);
      // If it's a new day, reset counters
      if (parsed.date !== today) {
        contextData = {
          date: today,
          accuracyCount: 0,
          fluencyCount: 0,
          current: ''
        };
      } else {
        contextData = {
          date: parsed.date,
          accuracyCount: parsed.accuracyCount ?? 0,
          fluencyCount: parsed.fluencyCount ?? 0,
          current: parsed.current ?? ''
        };
      }
    } catch (error) {
      console.error('Error parsing practiceContext:', error);
    }
  }

  // Increment the appropriate counter
  if (pageType === 'accuracy') {
    contextData.accuracyCount++;
    contextData.current = `accuracy${contextData.accuracyCount}`;
  } else {
    contextData.fluencyCount++;
    contextData.current = `fluency${contextData.fluencyCount}`;
  }

  sessionStorage.setItem('practiceContext', JSON.stringify(contextData));
  return contextData.current;
};
